import Api from "../../Utils/Api";

// Add Assignee
export const addAssigneeApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "ADD_ASSIGNEE_REQUEST",
        });

        const { data } = await Api.post("tenders/add-or-update-tender-assignees", formData);

        dispatch({
            type: "ADD_ASSIGNEE_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "ADD_ASSIGNEE_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Get Assignee
export const getAssigneesApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_ASSIGNEES_REQUEST",
        });

        const { data } = await Api.post("users/tenders-users", formData);

        dispatch({
            type: "GET_ASSIGNEES_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_ASSIGNEES_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Add Comment
export const addCommentApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "ADD_COMMENT_REQUEST",
        });

        const { data } = await Api.post("comments", formData);

        dispatch({
            type: "ADD_COMMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "ADD_COMMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Add Document
export const addDocumentsApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "ADD_DOCUMENT_REQUEST",
        });

        const { data } = await Api.post("tenders/tender-document", formData);

        dispatch({
            type: "ADD_DOCUMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "ADD_DOCUMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Get Attachments
export const getAttachmentsApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_ATTACHMENT_REQUEST",
        });

        const { data } = await Api.post("tenders/get-tender-document-comments", formData);

        dispatch({
            type: "GET_ATTACHMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_ATTACHMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Apply Tenders
export const applyTenderApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "APPLY_TENDER_REQUEST",
        });

        const { data } = await Api.post("tenders/apply-tender", formData);

        dispatch({
            type: "APPLY_TENDER_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "APPLY_TENDER_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Get Department User
export const getDepartmentUserApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "GET_USER_DEPARTMENT_REQUEST",
        });

        const { data } = await Api.post("users/department-users", formData);

        dispatch({
            type: "GET_USER_DEPARTMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "GET_USER_DEPARTMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};

// Add Document
export const deleteDocumentsApi = (formData) => async (dispatch) => {
    try {
        dispatch({
            type: "DELETE_DOCUMENT_REQUEST",
        });

        const { data } = await Api.post("tenders/delete-document", formData);

        dispatch({
            type: "DELETE_DOCUMENT_SUCCESS",
            payload: data,
            success: true,
        });

    } catch (e) {
        dispatch({
            type: "DELETE_DOCUMENT_FAILED",
            payload: e?.response?.data?.message[0],
            success: false,
        });
    }
};